/* eslint-disable max-len */
import React from 'react';

export function FOIcon() {
  return (
    <svg fill="#000000" width="26" height="26" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" data-iconid="421525" data-svgname="Computer desk office">

      <title />

      <g data-name="Layer 5" id="Layer_5">

        <path d="M61,29H56a12,12,0,0,0-23.9,0H23V27h8V9H7V27h8v2H3v6H8V53h3v4h6V53H30V45H48V57h6V45h2V35h5ZM44,20a10,10,0,0,1,10,9H34.05A10,10,0,0,1,44,20ZM22,25H16V21h6ZM9,25V11H29V25H24V19H14v6Zm8,2h4v2H17ZM15,55H13V53h2Zm13-4H10V35H28V51Zm24,4H50V45h2Zm2-12H30V35H54Zm5-10H5V31H59Z" />

        <path d="M44,17a5,5,0,1,0-5-5A5,5,0,0,0,44,17Zm0-8a3,3,0,1,1-3,3A3,3,0,0,1,44,9Z" />

      </g>

    </svg>
  );
}
